import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Form, Dropdown, Table, Pagination } from "react-bootstrap";
import { Common, EmployeeIcons, SettingsIcons } from "../../assets/images";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { setShowExpensesExportDropdown } from "../../store/slices/lettersSlice";
import { useNavigate } from "react-router-dom";
import { LoaderBlue } from "../Lotties";
import { exportToCsv, exportToPDF } from "../../config";
import {
  setFilterExpensesPageNo,
  setFilterExpensesPageSize,
  setExpensesPageNo,
  setExpensesPageSize,
} from "../../store/slices/lettersSlice";
import { setViolationsChange } from "../../store/slices/commonSlice";
import { Expense } from "../../interfaces/letters";
// API imports
import { useDeleteExpenseMutation } from "../../services/Letters";
import ExpensesFilterModal, {
  FormProps,
} from "../Modals/expenses-filter-modal";
import Content from "../HR/get-expenses-api";
import { useReactToPrint } from "react-to-print";
import SelectSearch from "react-select-search";

const ViolationsLogSheets = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const tableRef = useRef(null);
  const [print, setPrint] = useState(false);
  const handlePrint = useReactToPrint({
    content: () => tableRef.current,
    onAfterPrint: () => setPrint(false),
  });
  const handlePrinted = async () => {
    await setPrint(true);
    handlePrint();
  };
  const state = useAppSelector((state) => state.letters);
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);
  const [deleteLoadingMap, setDeleteLoadingMap] = useState<{
    [key: string]: boolean;
  }>({});
  const violationChange = useAppSelector(
    (state) => state.common.violationsChange,
  );
  const employees = useAppSelector((state) => state.employee.allEmployeesList);
  // Options
  const options = employees.map((item) => ({
    name: item.empId + " - " + item.empName,
    value: item.empId,
  }));
  // Pagination && Filter
  const [filterInput, setFilterInput] = useState<FormProps>({
    projectId: "",
    fromDate: "",
    toDate: "",
    amountFrom: "",
    amountTo: "",
    payAbleBy: "",
    expenseType: "",
    expenseStatus: "",
    category: "",
  });
  const [filterSearch, setFilterSearch] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [query, setQuery] = useState("");
  const [search, setSearch] = useState("");
  const [filteredData, setFilteredData] = useState<Expense[]>([]);
  const totalPages = Math.ceil(
    state.expensesTotalPages / state.expensesPageSize,
  );
  const totalCount = filterSearch
    ? state.filterExpensesTotalPages
    : state.expensesTotalPages;

  const filterTotalPages = Math.ceil(
    state.filterExpensesTotalPages / state.filterExpensesPageSize,
  );

  // show 5 pages at a time in pagination bar and rest will be shown in next and previous
  const showPages = 5;
  const startPage =
    Math.floor((state.expensesPageNo - 1) / showPages) * showPages;
  const endPage = startPage + showPages;
  const pages = [...Array(totalPages).keys()].slice(startPage, endPage);
  const filterStartPage =
    Math.floor((state.filterExpensesPageNo - 1) / showPages) * showPages;
  const filterEndPage = filterStartPage + showPages;
  const filterPages = [...Array(filterTotalPages).keys()].slice(
    filterStartPage,
    filterEndPage,
  );
  // handle go to page number that is after the 4 pages of current page
  const handleGoToNextPages = () => {
    //   if it is in the last 5 pages then dont do anything
    if (state.expensesPageNo > totalPages - showPages) {
      return;
    }
    dispatch(setExpensesPageNo(state.expensesPageNo + showPages));
  };

  const handleGoToPreviousPages = () => {
    //   if it is in the first 5 pages then dont do anything
    if (state.expensesPageNo <= 5) {
      return;
    }
    dispatch(setExpensesPageNo(state.expensesPageNo - showPages));
  };

  const handleFilterGoToNextPages = () => {
    //   if it is in the last 5 pages then dont do anything
    if (state.filterExpensesPageNo > filterTotalPages - showPages) {
      return;
    }
    dispatch(setFilterExpensesPageNo(state.filterExpensesPageNo + showPages));
  };

  const handleFilterGoToPreviousPages = () => {
    //   if it is in the first 5 pages then dont do anything
    if (state.filterExpensesPageNo <= 5) {
      return;
    }
    dispatch(setFilterExpensesPageNo(state.filterExpensesPageNo - showPages));
  };

  const handlePageChange = (page: any) => {
    dispatch(setExpensesPageNo(page));
  };

  const handleFilterPageChange = (page: any) => {
    dispatch(setFilterExpensesPageNo(page));
  };

  const handlePageSizeChange = (event: any) => {
    const selectedPageSize = parseInt(event.target.value, 10); // Parse the value to a number
    if (filterSearch) {
      dispatch(setFilterExpensesPageSize(selectedPageSize));
    } else {
      dispatch(setExpensesPageSize(selectedPageSize));
    }
  };
  useEffect(() => {
    setFilteredData(state.expenses);
  }, [state.expenses]);

  // Table Data
  const tableData = {
    tableHeading: [
      "Sr. No.",
      "Violation Date",
      "Emp Code",
      "Emp Name",
      "Project Id.",
      "Expense Type",
      "Category",
      "Expense Amount",
      "Expense Payable",
      "Expense Status",
      "Expense Detail",
      "Actions",
    ],
    tableData: filteredData,
  };

  const csvData = tableData.tableData.map((item, index) => ({
    "Sr. No.": index + 1,
    "Emp Code": item.empId,
    "Emp Name": item.empName,
    "Project Id.": item.projectId,
    "Expense Date": item.expenseDate
      ? new Date(item.expenseDate).toLocaleDateString()
      : "",
    "Expense Type": item.expenseType,
    Category: item.category,
    "Expense Amount": item.expenseAmount,
    "Expense Payable": item.payAbleBy,
    "Expense Status": item.expenseStatus,
    "Expense Detail": item.expenseDetail,
  }));

  // Delete Violation

  const [deleteExpense] = useDeleteExpenseMutation();

  const handleDelete = async (leaveId: string) => {
    setDeleteLoadingMap((prevMap) => ({ ...prevMap, [leaveId]: true }));
    try {
      const data = {
        userID: userID || "",
        accessToken: accessToken || "",
        permission: profileData.permissions.deleteEmployee || false,
        payload: {
          expenseId: leaveId,
        },
      };
      await deleteExpense(data).unwrap();
      dispatch(setViolationsChange(!violationChange));
    } catch (e) {
      console.log(e);
    } finally {
      setDeleteLoadingMap((prevMap) => ({ ...prevMap, [leaveId]: false }));
    }
  };

  const handleReset = () => {
    setQuery("");
    setSearch("");
    setFilteredData(state.expenses);
    setFilterSearch(false);
    setFilterInput({
      projectId: "",
      fromDate: "",
      toDate: "",
      amountFrom: "",
      amountTo: "",
      payAbleBy: "",
      expenseType: "",
      expenseStatus: "",
      category: "",
    });
  };

  const twoWords = (name: string) => {
    const words = name.split(" ");
    return words[0] + " " + words[1];
  };

  return (
    <div className=" mt-2 section px-4 py-4">
      <Content />
      <ExpensesFilterModal
        show={showFilterModal}
        setShow={setShowFilterModal}
        setExpenses={setFilteredData}
        filterSearch={filterSearch}
        setFilterSearch={setFilterSearch}
        expenses={state.expenses}
        query={query}
        filterInput={filterInput}
        setFilterInput={setFilterInput}
      />
      <Row>
        <Col sm="12">
          <div className="section-heading mb-4">
            <h1 className="heading mb-0">Violations / Fines</h1>
            <div className="d-flex align-items-center justify-content-between mt-4">
              <div
                className=" d-flex align-items-center gap-2"
                style={{ width: "25%" }}
              >
                <Form.Group className="w-100" controlId="formBasicEmail">
                  <Form.Group className="position-relative input-design d-flex align-items-center">
                    <SelectSearch
                      options={options}
                      onChange={(value: any) => {
                        setQuery(value);
                        setFilterSearch(true);
                      }}
                      value={query}
                      search={true}
                      placeholder="Search Employee by Id/Name "
                    />
                    <img src={Common.ArrowDown} alt="message" />
                  </Form.Group>
                </Form.Group>
                {query !== "" ? (
                  <button
                    type="button"
                    className="btn primary-button w-25"
                    onClick={handleReset}
                  >
                    {" "}
                    Reset
                  </button>
                ) : filterSearch ? (
                  <button
                    type="button"
                    className="btn primary-button w-25"
                    onClick={handleReset}
                  >
                    {" "}
                    Reset
                  </button>
                ) : null}
              </div>
              <div className="d-flex align-items-center gap-4">
                <button
                  className="dropdown-toggle-white dropdown-toggle-blue"
                  type="button"
                  onClick={() => navigate("/employees/fine-clearance")}
                >
                  <img src={Common.Plus} height="22px" width="22px" alt="img" />{" "}
                  New
                </button>
                <button
                  id="dropdown-basic"
                  onClick={() => {
                    setShowFilterModal(true);
                  }}
                  className="dropdown-toggle-white dropdown-toggle-blue"
                >
                  Filter{" "}
                </button>
                <Dropdown
                  show={state.showExpensesExportDropdown}
                  className="position-relative"
                >
                  <button
                    id="dropdown-basic"
                    onClick={() => {
                      dispatch(
                        setShowExpensesExportDropdown(
                          !state.showExpensesExportDropdown,
                        ),
                      );
                    }}
                    className=" bg-transparent dropdown-toggle-white"
                  >
                    Export{" "}
                    <img
                      src={EmployeeIcons.ArrowDownBlue}
                      className="ms-2"
                      alt="down-arrow"
                    />
                  </button>
                  <Dropdown.Menu
                    className="mt-1 custom-scrollbar"
                    show={state.showExpensesExportDropdown}
                  >
                    <Dropdown.Item
                      onClick={() => {
                        exportToCsv(csvData, "expenses-list");
                        dispatch(setShowExpensesExportDropdown(false));
                      }}
                    >
                      CSV
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => {
                        dispatch(setShowExpensesExportDropdown(false));
                        handlePrinted();
                      }}
                    >
                      PDF
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
        </Col>
        <Col sm="12">
          {state.expensesLoading ? (
            <LoaderBlue height={70} width={70} />
          ) : profileData.permissions.showEmployee ? (
            <>
              {tableData.tableData.length > 0 ? (
                <div className="p-3" ref={tableRef}>
                  {print && (
                    <>
                      <div className="d-flex align-items-center justify-content-between">
                        <div>
                          <img src={Common.Vision} width="110px" alt="logo" />
                        </div>
                        <div className="letter-logo text-center gap-2">
                          <img src={Common.LogoSVG} width="80px" alt="logo" />
                          <div className="mt-1">
                            <h3
                              className="logo-text mb-0"
                              style={{
                                color: "#202020",
                                fontSize: "10px",
                                fontWeight: "700",
                              }}
                            >
                              Senyar Arabian Trading Co. LTD
                            </h3>
                            <h3
                              className="logo-text logo-arabic mb-0"
                              style={{
                                color: "#202020",
                                fontSize: "13px",
                                fontWeight: "700",
                              }}
                            >
                              شركة سنيار العربية التجارية المحدودة
                            </h3>
                          </div>
                        </div>
                      </div>
                      <h1 className="sub-heading text-center mt-3">
                        Employees Violations/Fines List
                      </h1>
                    </>
                  )}
                  <Table
                    striped
                    bordered
                    responsive
                    className={
                      print
                        ? "mt-5 text-center print-table"
                        : "mt-5 text-center"
                    }
                  >
                    <thead>
                      <tr className="border-0">
                        {tableData.tableHeading.map((item, index) => (
                          <th
                            className={
                              item === "Actions" && print
                                ? "border-0 d-none"
                                : "border-0"
                            }
                            key={index}
                          >
                            {item}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {tableData.tableData.map((item, index) => (
                        <tr
                          key={index}
                          style={{ borderColor: "rgba(32, 32, 32, 0.20)" }}
                        >
                          <td>
                            {totalCount > 0
                              ? filterSearch
                                ? (state.filterExpensesPageNo - 1) *
                                    state.filterExpensesPageSize +
                                  index +
                                  1
                                : (state.expensesPageNo - 1) *
                                    state.expensesPageSize +
                                  index +
                                  1
                              : index + 1}
                          </td>
                          <td>
                            {item.expenseDate
                              ? new Date(item.expenseDate).toLocaleDateString()
                              : ""}
                          </td>
                          <td>{item.empId}</td>
                          <td>
                            {print ? twoWords(item.empName) : item.empName}
                          </td>
                          <td>{item.projectId}</td>

                          <td>{item.expenseType}</td>
                          <td>{item.category}</td>
                          <td>{item.expenseAmount}</td>
                          <td>{item.payAbleBy}</td>
                          <td>
                            <p
                              className="mb-0 py-1 px-4 text-white mx-auto"
                              style={{
                                background:
                                  item.expenseStatus === "Cleared"
                                    ? "rgba(57, 179, 89, 1)"
                                    : "rgba(239, 148, 0, 1)",
                                width: "fit-content",
                                borderRadius: "20px",
                              }}
                            >
                              {item.expenseStatus}
                            </p>
                          </td>
                          <td>{item.expenseDetail}</td>
                          {!print && (
                            <td>
                              <button
                                className="btn p-0 border-0 me-2"
                                onClick={() =>
                                  navigate(`/hr/view-expense/${item.empId}`, {
                                    state: { data: item },
                                  })
                                }
                              >
                                <img
                                  src={Common.Eye}
                                  width="30px"
                                  height="30px"
                                  alt="edit-user"
                                />
                              </button>
                              {item.expenseStatus === "Pending" && (
                                <button
                                  className="btn p-0 border-0 me-2"
                                  onClick={() =>
                                    navigate(
                                      `/employees/edit-fine-clearance/${item.empId}`,
                                      { state: { data: item } },
                                    )
                                  }
                                >
                                  <img
                                    src={SettingsIcons.EditUser}
                                    width="30px"
                                    height="30px"
                                    alt="edit-user"
                                  />
                                </button>
                              )}
                              {deleteLoadingMap[item._id] ? (
                                <LoaderBlue height={20} width={20} />
                              ) : (
                                <button
                                  className="btn p-0 border-0"
                                  onClick={() => handleDelete(item._id)}
                                >
                                  <img
                                    src={SettingsIcons.Delete}
                                    width="24px"
                                    height="24px"
                                    alt="edit-user"
                                  />
                                </button>
                              )}
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              ) : (
                <div className="text-center mt-5">
                  <h1 className="heading">No Violations Found</h1>
                </div>
              )}
            </>
          ) : (
            <div className="text-center mt-5">
              <h1 className="heading">Unauthorized Access</h1>
            </div>
          )}
        </Col>
        {filteredData.length > 0 && (
          <Col sm="12">
            <div className="mt-3 d-flex justify-content-between align-items-center">
              <Form.Group
                className="d-flex align-items-center gap-2"
                controlId="formBasicEmail"
              >
                <h4
                  className="sub-heading normal-font-weight textBlack"
                  style={{ fontSize: "14px", width: "230px" }}
                >
                  Entries per page
                </h4>
                <Form.Select
                  name="pageSize"
                  onChange={handlePageSizeChange}
                  value={
                    filterSearch
                      ? state.filterExpensesPageSize.toString()
                      : state.expensesPageSize.toString()
                  }
                  className="custom-input border-fill custom-height"
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="100">100</option>
                  <option value="10000">All</option>
                </Form.Select>
              </Form.Group>
              <div className="pagination-custom">
                <Pagination className="justify-content-end">
                  <Pagination.Item
                    onClick={() =>
                      filterSearch
                        ? handleFilterGoToPreviousPages()
                        : handleGoToPreviousPages()
                    }
                  >
                    <img src={Common.DoubleArrowLeft} alt="arrow" />
                  </Pagination.Item>
                  <Pagination.Item
                    onClick={() =>
                      filterSearch
                        ? handleFilterPageChange(
                            state.filterExpensesPageNo > 1
                              ? state.filterExpensesPageNo - 1
                              : 1,
                          )
                        : handlePageChange(
                            state.expensesPageNo > 1
                              ? state.expensesPageNo - 1
                              : 1,
                          )
                    }
                  >
                    <img
                      src={EmployeeIcons.ArrowDownBlue}
                      className="rotate-left"
                      alt="arrow"
                    />
                  </Pagination.Item>
                  {filterSearch ? (
                    <>
                      {/* render filter pages here */}
                      {filterPages.map((page, index) => (
                        <Pagination.Item
                          key={index}
                          onClick={() => handleFilterPageChange(page + 1)}
                          className={
                            page + 1 === state.filterExpensesPageNo
                              ? "active-page"
                              : ""
                          }
                        >
                          {page + 1}
                        </Pagination.Item>
                      ))}
                    </>
                  ) : (
                    <>
                      {/* render pages here */}
                      {pages.map((page, index) => (
                        <Pagination.Item
                          key={index}
                          onClick={() => handlePageChange(page + 1)}
                          className={
                            page + 1 === state.expensesPageNo
                              ? "active-page"
                              : ""
                          }
                        >
                          {page + 1}
                        </Pagination.Item>
                      ))}
                    </>
                  )}
                  <Pagination.Item
                    onClick={() =>
                      filterSearch
                        ? handleFilterPageChange(
                            state.filterExpensesPageNo < filterTotalPages
                              ? state.filterExpensesPageNo + 1
                              : filterTotalPages,
                          )
                        : handlePageChange(
                            state.expensesPageNo < totalPages
                              ? state.expensesPageNo + 1
                              : totalPages,
                          )
                    }
                  >
                    <img
                      src={EmployeeIcons.ArrowDownBlue}
                      className="rotate-right"
                      alt="arrow"
                    />
                  </Pagination.Item>
                  <Pagination.Item
                    onClick={() => {
                      filterSearch
                        ? handleFilterGoToNextPages()
                        : handleGoToNextPages();
                    }}
                  >
                    <img src={Common.DoubleArrowRight} alt="arrow" />
                  </Pagination.Item>
                </Pagination>
              </div>
            </div>
          </Col>
        )}
      </Row>
    </div>
  );
};
export default ViolationsLogSheets;
